import { Box, Skeleton } from '@mui/material';

export default function DeviceSkeleton() {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', px: 1.5, py: 0.5, gap: 0.75 }}>
            {/* RssFeedIcon */}
            <Skeleton variant="circular" width={14} height={14} sx={{ flexShrink: 0 }} />
            {/* DeviceName */}
            <Skeleton variant="text" sx={{ fontSize: 'body2.fontSize' }} width="45%" />
            <Box sx={{ flex: 1 }} />
            {/* SensorStateIcon */}
            <Skeleton variant="circular" width={18} height={18} sx={{ flexShrink: 0 }} />
            {/* SignalLevel */}
            <Skeleton variant="rounded" width={18} height={14} sx={{ flexShrink: 0 }} />
            {/* BatteryLevel */}
            <Skeleton variant="rounded" width={24} height={12} sx={{ flexShrink: 0 }} />
            {/* status dot */}
            <Skeleton variant="circular" width={10} height={10} sx={{ flexShrink: 0, ml: 0.5 }} />
        </Box>
    );
}
